export const CLEAR_THUMBNAILS = 'CLEAR_THUMBNAILS';
export const DELETE_THUMBNAIL = 'DELETE_THUMBNAIL';
export const MEDIA_TYPE = 'MEDIA_TYPE';
export const THUMBNAILS = 'THUMBNAILS';
